import React from 'react';

import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { spaceHeaderID } from './SpaceHeaderWithTotalItemsCount';

export function SpaceHeaderContent(props: { headerText: string, testId?: string, renderSideContent?: () => JSX.Element, onClick?: () => void }): JSX.Element {
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return <div className={ExplorerStyles.SpaceHeaderContent} onClick={props.onClick}>
        <h1 id={spaceHeaderID} className={ExplorerStyles.SpaceHeaderText} data-tb-test-id={props.testId}>{props.headerText}</h1>
        {props.renderSideContent && props.renderSideContent()}
    </div>;
}